import { BranchDesignator } from "@fusion-advantage/backcompat"
import { V2L1DesignatorGel } from "../../Indicator/V2L1DesignatorGel"
import { faBug, faHouse, faVideo } from "@fortawesome/pro-regular-svg-icons"
import { FusionColor } from "../../../../theme/FusionStyle"

interface V2L2WorkItemBranchDesignatorProps {
	designator: BranchDesignator
}

export const V2L2WorkItemBranchDesignator = ({designator}: V2L2WorkItemBranchDesignatorProps) => {
	switch(designator) {
		case BranchDesignator.VideoVisit:
			return (
				<V2L1DesignatorGel
					icon={faVideo}
					color={FusionColor.BlueLight2}
					title="Video"
				/>
			)
		case BranchDesignator.InHome:
			return (
				<V2L1DesignatorGel
					icon={faHouse}
					color={FusionColor.OrangeLight2}
					title="In-Home"
				/>
			)
		default:
			return (
				<V2L1DesignatorGel
					icon={faBug}
					color={FusionColor.ErrorRed}
					title="Unknown"
				/>
			)
	}
}
